import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

const Post = () => {
    const [post, setPost] = useState(null);
    const { slug } = useParams();

    useEffect( () => {
        const fetchPost = async () => {
            const response = await axios.get(`https://unieros.com/wp/wp-json/wp/v2/posts?slug=${slug}&_embed=tags`);
            setPost(response.data[0]);
        };
        fetchPost();
    }, [slug]);
    if (!post) return 'Loading...';
    
    return (
        <div className="container">
            <h1>{post.title.rendered}</h1>
            <div className="row" dangerouslySetInnerHTML={{__html:post.content.rendered}} />
            <div className="tags">
        {post._embedded && post._embedded['wp:term'] && post._embedded['wp:term'][1].map((tag) => (
          <span key={tag.id} className="badge badge-danger">{tag.name}</span>
        ))}
      </div>
        </div>
    );
};

export default Post;